import { jsxs as B, jsx as m } from "react/jsx-runtime";
import { clsx as x } from "../../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { useId as O, useRef as P, useState as T, useEffect as V } from "react";
import { getCssAspectRatio as $ } from "../../image/roche-image-helpers.js";
import b from "../roche-video-player.module.scss.js";
import { RocheUIVideoPlayerControls as j } from "../roche-video-player-controls.js";
import { RocheUIVideoPlayerPreviewImage as G } from "../roche-video-player-preview-image.js";
import { useYouTubeAPI as K } from "./use-youtube-api.js";
import { getVideoPercentage as L } from "./youtube-utils.js";
const C = 1e3, ee = ({
  videoId: a,
  fullscreen: n,
  preview: I,
  previewAlt: v,
  pauseLabel: Y,
  playLabel: k,
  onVideoStateChange: o,
  videoRatio: p
}) => {
  const c = K(), l = `yt-video-${O()}`, r = P(null), f = P(null), [u, U] = T(!1), [y, g] = T(!1), [_, h] = T(""), E = P(), w = (e, t) => {
    const d = document.getElementById(l);
    d && (d.style.width = e ? "auto" : "100%", d.style.height = e ? "90% " : "auto", d.style.aspectRatio = $(t) ?? "16 / 9");
  }, N = () => {
    const e = document.getElementById(l);
    e && (e.style.display = "inline");
  }, s = (e) => ({
    videoId: a,
    videoTitle: e.getVideoData().title,
    videoType: "youtube",
    videoDurationTotal: e.getDuration(),
    videoPercentageViewed: L(e),
    videoUrl: e.getVideoUrl()
  }), D = (e) => {
    switch (e.data) {
      case YT.PlayerState.PLAYING:
        i(), E.current = setInterval(
          () => R(e.target),
          C
        ), o({
          type: "playing",
          base: { ...s(e.target) },
          trackingValue: "play"
        });
        break;
      case YT.PlayerState.ENDED:
        i(), o({
          type: "ended",
          base: { ...s(e.target) },
          trackingValue: "end"
        });
        break;
      case YT.PlayerState.PAUSED:
        i(), R(e.target), o({
          type: "pause",
          base: { ...s(e.target) },
          trackingValue: "pause"
        });
        break;
      default:
        i();
    }
  }, i = () => {
    clearInterval(E.current);
  }, R = (e) => {
    o({
      type: "timeupdate",
      base: { ...s(e) },
      trackingValue: "timeupdate"
    });
  };
  V(() => {
    if (c && f.current && !r.current && a && typeof YT < "u" && YT.Player)
      try {
        r.current = new YT.Player(f.current, {
          videoId: a,
          playerVars: {
            autoplay: 0,
            controls: 1
          },
          host: "https://www.youtube-nocookie.com",
          events: {
            onReady: (e) => {
              U(!0);
              const t = document.getElementById(l);
              t && (t.style.display = "none"), h(e.target.getVideoData().title);
            },
            onStateChange: D,
            onError: (e) => {
              const t = (e == null ? void 0 : e.data) || "YOUTUBE_UNKNOWN_ERROR";
              i(), g(!1), o({
                type: "error",
                base: { ...s(e.target) },
                trackingValue: "videoError",
                errorCode: t
              });
            }
          }
        });
      } catch (e) {
        console.error(`Failed to create YouTube Player with videoId: ${a} - Error: ${e.message}`);
      }
  }, [c, a]), V(() => {
    u && w(n, p);
  }, [u, n, p]);
  const A = () => {
    g(!0), c && r.current && u && (N(), r.current.playVideo());
  }, S = () => {
    g(!1), c && r.current && u && r.current.pauseVideo();
  };
  return /* @__PURE__ */ B("div", { className: b["video-player__service--youtube"], children: [
    I && /* @__PURE__ */ m(
      G,
      {
        preview: I,
        previewAlt: v,
        isPlaying: y,
        fullscreen: n,
        error: y && !a,
        videoRatio: p
      }
    ),
    /* @__PURE__ */ m(
      "div",
      {
        className: x(
          b["video-player__content--absolute"],
          y && b["video-player__content--absolute-active"]
        ),
        children: /* @__PURE__ */ m("div", { id: l, ref: f })
      }
    ),
    /* @__PURE__ */ m(
      j,
      {
        onPlay: A,
        onPause: S,
        isPlaying: y,
        pauseLabel: Y,
        playLabel: k,
        videoTitle: _,
        fullscreen: n
      }
    )
  ] });
};
export {
  ee as YouTubeVideoPlayerService
};
